var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-tools-container"},_vm._l((_vm.projectTools),function(toolImg,i){return _c('div',{key:"a" + i},[_c('img',{attrs:{"src":require('@/assets/logos/' + toolImg)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }